import React, { useRef, forwardRef } from "react";
import { motion } from "framer-motion";
import { useIntersection, useMedia } from "react-use";

import { fadeInUp } from "data/animations";

function VisibleComponent(props) {
  const { children, parent, child, ...rest } = props;
  const targetRef = useRef(null);
  const intersection = useIntersection(targetRef, {
    root: null,
    rootMargin: "0px",
    threshold: 1
  });
  const isMobile = useMedia("(max-width: 640px)");

  const visible = intersection && intersection.intersectionRatio;

  if (isMobile) return children;

  if (child) {
    return (
      <motion.div
        {...rest}
        children={children}
        transition={{ ease: [0.23, 1, 0.32, 1], duration: 1 }}
        variants={{
          visible: { opacity: 1, y: 0 },
          hidden: { opacity: 0, y: 20 }
        }}
      />
    );
  }

  if (parent) {
    return (
      <motion.div
        {...rest}
        ref={targetRef}
        children={children}
        initial="hidden"
        animate={visible > 0 ? "visible" : "hidden"}
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.1
            }
          }
        }}
      />
    );
  }

  return (
    <motion.div
      {...rest}
      {...fadeInUp(props)}
      children={children}
      ref={targetRef}
      initial="hidden"
      animate={visible > 0 ? "visible" : "hidden"}
    />
  );
}

export default VisibleComponent;
